//FormBuilder components
import ElementModel from "./ElementModel"

//Prime react
import { Menu } from "primereact/menu"
import { Tooltip } from "primereact/tooltip"

//Styles
import myStyles from "../../../../../styles/assessments/ManagementFormBuilder.module.css"
import elementTypes from "./elementTypes"
import Draggable from "../Draggable"

export default function FormBuilderElements({ disabled }) {
  const elementTemplate = (item) => {
    return (
      <Draggable id={item.id} data={{ element: item }} disabled={disabled}>
        <ElementModel element={item} key={item.id} />
      </Draggable>
    )
  }

  const elementOptions = [
    {
      label: "Basic elements",
      items: elementTypes.basicElements.map((element) => {
        return { ...element, template: elementTemplate }
      }),
    },
  ]

  const advancedElementOptions = [
    {
      label: "Special elements",
      items: elementTypes.specialElements.map((element) => {
        return { ...element, template: elementTemplate }
      }),
    },
  ]

  return (
    <div className={myStyles.elementMenuContainer}>
      <Tooltip target=".tt-element" />
      <Menu model={elementOptions} className={myStyles.elementMenu}></Menu>
      <Menu
        model={advancedElementOptions}
        className={myStyles.elementMenu}
      ></Menu>
    </div>
  )
}
